import { parseShortcut, isTypingContext, matchesShortcut } from "./shortcutParsing";

let registered = false;

export function registerKeyboardShortcut(
  keyboard: { enabled: boolean; shortcut: string } | undefined,
  onTrigger: () => void
): void {
  if (registered) return;
  if (!keyboard?.enabled || !keyboard.shortcut) return;

  const parsed = parseShortcut(keyboard.shortcut);
  document.addEventListener("keydown", (event: KeyboardEvent) => {
    if (isTypingContext(event.target)) return;
    if (matchesShortcut(event, parsed)) {
      event.preventDefault();
      onTrigger();
    }
  });
  registered = true;
}
